/* **************************************************** Finishing Shedule Color */
export interface FSColor {
    id: number;
    category: string;
    sub_category: string;
    color_name: string;
    color_code: string;
    created_by: number | null;
}

export const mapFSColor = (data: any): FSColor => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSColor = {
        id: data.id,
        category: data.category,
        sub_category: data.sub_category,
        color_name: data.color_name,
        color_code: data.color_code,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSColors = (data: any[]): FSColor[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSColor);
};
